import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// ✅ 快取正則，避免每次呼叫重建
const LANG_PREFIX_RE = /^\/(en|zh|ja)(\/|$)/;

export const useLanguageNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language, changeLanguage } = useLanguage();

  // 切換語言（保持在當前頁面）
  const switchLanguage = useCallback((newLang) => {
    const pathWithoutLang = location.pathname.replace(LANG_PREFIX_RE, '/');
    const newPath = (pathWithoutLang === '/' || pathWithoutLang === '')
      ? `/${newLang}`
      : `/${newLang}${pathWithoutLang}`;
    changeLanguage(newLang);
    navigate(newPath, { replace: true });
  }, [location.pathname, language, changeLanguage, navigate]);

  // 導航到指定路徑（自動添加語言前綴）
  const navigateWithLanguage = useCallback((path, options = {}) => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    const hasLangPrefix = LANG_PREFIX_RE.test(`/${cleanPath}`);
    const fullPath = hasLangPrefix
      ? `/${cleanPath}`
      : cleanPath ? `/${language}/${cleanPath}` : `/${language}`;
    navigate(fullPath, options);
  }, [language, navigate]);

  const currentPath = location.pathname.replace(LANG_PREFIX_RE, '/') || '/';

  return {
    language,
    switchLanguage,
    navigateWithLanguage,
    navigateTo: navigateWithLanguage,
    currentPath,
  };
};

export default useLanguageNavigation;